import type { MetricKey } from '../../utils/types.ts';

export const metricsOrder: MetricKey[] = [
  'totalBidSpendInUsd',
  'relevance',
  'totalCprMarketRequests',
  'totalImpressions',
  'avgBidCpm',
  'avgViewability',
  'avgPubWinRate',
  'avgOxWinRate',
];
